import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATH_NAME } from '../../Routes/Pathname';
import { setAccessToken } from '../../Utils/storage/user';
import { Button, Link, TextField, Typography } from '@mui/material';
import { AppColors } from '../../Utils/helper/AppColors';
import LabelledInput from '../../Components/LabelledInput';
import googleIcon from '../../Assets/Icons/google.svg';
import { FaApple } from 'react-icons/fa';
import LoginLayout from './Components/LoginLayout';
import CultService from '../../Services/CultService';
import toast from 'react-hot-toast';
// import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setCompany, setProfile, setUser } from '../../store/reducers/appActions';
import { HelperTexts } from '../../Utils/helper/HelperTexts';
import { SIGN_UP_FLOW } from '../../Utils/helper/AppConstants';
import { setCriticalRecords, setHarassmentTendencies, setSuicidalTendencies } from '../../Utils/storage/criticalRecords';
import { IconButton, InputAdornment } from '@mui/material';

import { EyeIcon, EyeSlashIcon } from '../../Components/Icons/Icons';

export default function Login() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [data, setData] = useState({});
	const [loading, setLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const themeId = process.env.REACT_APP_THEME_ID;


	const profile = useSelector((state) => ({
		name: state.app.name,
		logoUrl: state.app.logoUrl,
	}))
   console.log('profile', profile);

	const getThemeById = async (id) => {
		const res = await CultService.getThemeById({ params: { themeId : id } });
		console.log('res', res);
		dispatch(setProfile({name: res?.data?.data?.name , logoUrl: res?.data?.data?.logoUrl}));
		if (res.status === 200) {
			localStorage.setItem('navSettings', JSON.stringify(res?.data?.data));
			window.dispatchEvent(new Event('navSettingsChanged')); 
		} else {
			toast.error(HelperTexts.SOMETHING_WENT_WRONG);
		}
	}

	const handleToggleVisibility = () => {
		setShowPassword((prev) => !prev);
	};

	const handleInputChange = (e) => {
		setData({ ...data, [e.target.name]: e.target.value });
	};

	const handleLogin = async () => {
		if (!data?.email || !data?.password) return;
		setLoading(true);
		try {
			let res = await CultService.login({ data });
			if (res.status == 200) {
				localStorage.setItem('userId', res?.data?.data?.id);
				setAccessToken(res?.data?.data?.token);

				if (res?.data?.data?.criticalRecords) {
					let criticalRecords = res?.data?.data?.criticalRecords;

					//  let harassmentTendenciesData = [
					// 	{
					// 		"id": "67ee8b472499540ad7a6bee9",
					// 		"hasHarassmentTendencies": true,
					// 		"hasSuicidalTendencies": false,
					// 		"userId": {
					// 			"_id": "678e9237ab00505704b9587e",
					// 			"firstName": "Vishal",
					// 			"lastName": "Bhardwaj",
					// 			"email": "vishalbhardwajcs@gmail.com",
					// 			"id": "678e9237ab00505704b9587e"
					// 		},
					// 		"summary": "The employee expressed feeling pressured and harassed by their manager, leading to mental distress. The AI HR showed empathy and offered support, encouraging the employee to share their concerns openly."
					// 	},
					// 	{
					// 		"id": "67ee8b472499540ad7a6bee5",
					// 		"hasHarassmentTendencies": true,
					// 		"hasSuicidalTendencies": false,
					// 		"summary": "The employee expressed feeling pressured and harassed by their manager, leading to mental distress. The AI HR showed empathy and offered support, encouraging the employee to share their concerns openly."
					// 	},
					// 	{
					// 		"id": "67ee8b472499540ad7a6bee4",
					// 		"hasHarassmentTendencies": true,
					// 		"hasSuicidalTendencies": false,
					// 		"summary": "The employee expressed feeling pressured and harassed by their manager, leading to mental distress. The AI HR showed empathy and offered support, encouraging the employee to share their concerns openly."
					// 	},
					// 	{
					// 		"id": "67ee8b472499540ad7a6bee3",
					// 		"hasHarassmentTendencies": true,
					// 		"hasSuicidalTendencies": false,
					// 		"summary": "The employee expressed feeling pressured and harassed by their manager, leading to mental distress. The AI HR showed empathy and offered support, encouraging the employee to share their concerns openly."
					// 	},
					// 	{
					// 		"id": "67ee8b472499540ad7a6bee2",
					// 		"hasHarassmentTendencies": true,
					// 		"hasSuicidalTendencies": false,
					// 		"userId": {
					// 			"_id": "678e9237ab00505704b9587e",
					// 			"firstName": "Vishal",
					// 			"lastName": "Bhardwaj",
					// 			"email": "vishalbhardwajcs@gmail.com",
					// 			"id": "678e9237ab00505704b9587e"
					// 		},
					// 		"summary": "The employee expressed feeling pressured and harassed by their manager, leading to mental distress. The AI HR showed empathy and offered support, encouraging the employee to share their concerns openly."
					// 	},
					// 	{
					// 		"id": "67ee8b472499540ad7a6bee1",
					// 		"hasHarassmentTendencies": true,
					// 		"hasSuicidalTendencies": false,
					// 		"userId": {
					// 			"_id": "678e9237ab00505704b9587e",
					// 			"firstName": "Vishal",
					// 			"lastName": "Bhardwaj",
					// 			"email": "vishalbhardwajcs@gmail.com",
					// 			"id": "678e9237ab00505704b9587e"
					// 		},
					// 		"summary": "The employee expressed feeling pressured and harassed by their manager, leading to mental distress. The AI HR showed empathy and offered support, encouraging the employee to share their concerns openly."
					// 	},
					// 	{
					// 		"id": "67ee8b472499540ad7a6bee0",
					// 		"hasHarassmentTendencies": true,
					// 		"hasSuicidalTendencies": false,
					// 		"userId": {
					// 			"_id": "678e9237ab00505704b9587e",
					// 			"firstName": "Vishal",
					// 			"lastName": "Bhardwaj",
					// 			"email": "vishalbhardwajcs@gmail.com",
					// 			"id": "678e9237ab00505704b9587e"
					// 		},
					// 		"summary": "The employee expressed feeling pressured and harassed by their manager, leading to mental distress. The AI HR showed empathy and offered support, encouraging the employee to share their concerns openly."
					// 	}
					//  ];
					//  let suicidalTendenciesData = [
					// 	{
					// 		"id": "67ee8b472499540ad7a6bee9",
					// 		"hasHarassmentTendencies": true,
					// 		"hasSuicidalTendencies": false,
					// 		"userId": {
					// 			"_id": "678e9237ab00505704b9587e",
					// 			"firstName": "Vishal",
					// 			"lastName": "Bhardwaj",
					// 			"email": "vishalbhardwajcs@gmail.com",
					// 			"id": "678e9237ab00505704b9587e"
					// 		},
					// 		"summary": "The employee expressed feeling pressured and harassed by their manager, leading to mental distress. The AI HR showed empathy and offered support, encouraging the employee to share their concerns openly."
					// 	},
					// 	{
					// 		"id": "67ee8b472499540ad7a6bee5",
					// 		"hasHarassmentTendencies": true,
					// 		"hasSuicidalTendencies": false,
					// 		"summary": "The employee expressed feeling pressured and harassed by their manager, leading to mental distress. The AI HR showed empathy and offered support, encouraging the employee to share their concerns openly."
					// 	},
					// 	{
					// 		"id": "67ee8b472499540ad7a6bee4",
					// 		"hasHarassmentTendencies": true,
					// 		"hasSuicidalTendencies": false,
					// 		"summary": "The employee expressed feeling pressured and harassed by their manager, leading to mental distress. The AI HR showed empathy and offered support, encouraging the employee to share their concerns openly."
					// 	},
					// 	{
					// 		"id": "67ee8b472499540ad7a6bee3",
					// 		"hasHarassmentTendencies": true,
					// 		"hasSuicidalTendencies": false,
					// 		"summary": "The employee expressed feeling pressured and harassed by their manager, leading to mental distress. The AI HR showed empathy and offered support, encouraging the employee to share their concerns openly."
					// 	}];

					let harassmentTendenciesData = [];
					let suicidalTendenciesData = [];

					criticalRecords.forEach((record) => {
						if (record?.hasHarassmentTendencies) {
							harassmentTendenciesData.push({
								id: record?._id,
								hasHarassmentTendencies: record?.hasHarassmentTendencies,
								hasSuicidalTendencies: record?.hasSuicidalTendencies,
								summary: record?.callSummary?.summary,
								...(!record?.anonymous && { userId: record?.userId }),
							});
						} 
						
						if (record?.hasSuicidalTendencies) {
							suicidalTendenciesData.push({
								id: record?._id,
								hasHarassmentTendencies: record?.hasHarassmentTendencies,
								hasSuicidalTendencies: record?.hasSuicidalTendencies,
								summary: record?.callSummary?.summary,
								...(!record?.anonymous && { userId: record?.userId }),
							});
						}
					});

					if (harassmentTendenciesData.length > 0) {
						setHarassmentTendencies(harassmentTendenciesData);
					}
					if (suicidalTendenciesData.length > 0) {
						setSuicidalTendencies(suicidalTendenciesData);
					}
				}

				navigate(PATH_NAME.DASHBOARD);
				let user = await CultService.getUserById({ params: { id: res?.data?.data?.id } });
				if (user.status == 200) {
					localStorage.setItem('user', JSON.stringify(user?.data?.data));
					dispatch(setUser(user?.data?.data));
					dispatch(setCompany(user?.data?.data?.company));
				}
			}
		} catch (err) {
			toast.error(err?.response?.data?.message || HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setLoading(false);
		}
	};


	useEffect(() => {
		console.log('themeId', themeId);
		let localData = JSON.parse(localStorage.getItem('navSettings'));
		if (!themeId || localData) return;
	    getThemeById(themeId);
	}, []);


	return (
		<LoginLayout heading="Welcome Back!" subHeading="Please enter login details below" textLogo={profile?.name || 'CultureOS'}>
			<TextField
				placeholder="Email"
				name="email"
				onChange={handleInputChange}
				fullWidth
				InputProps={{
					sx: {
						backgroundColor: '#fff',
						borderRadius: '12px',
						height: '56px',
						px: 2,
						'& input::placeholder': {
							color: '#000',
							opacity: 0.7,
							fontWeight: 500,
						},
						'& input:-webkit-autofill': {
							boxShadow: '0 0 0 1000px #fff inset',
							WebkitTextFillColor: '#000',
							fontWeight: 500,
						},
					},
				}}
				sx={{
					'& .MuiOutlinedInput-root': {
						'& fieldset': {
							borderColor: '#fff',
						},
						'&:hover fieldset': {
							borderColor: '#ccc',
						},
						'&.Mui-focused fieldset': {
							borderColor: '#888',
						},
					},
				}}
			/>

			{/* Password Input */}
			<TextField
				placeholder="Password"
				name="password"
				type={showPassword ? 'text' : 'password'}
				onChange={handleInputChange}
				fullWidth
				InputProps={{
					endAdornment: (
						<InputAdornment position="end">
							<IconButton onClick={handleToggleVisibility} edge="end">
								{showPassword ? <EyeIcon /> : <EyeSlashIcon /> }
							</IconButton>
						</InputAdornment>
					),
					sx: {
						backgroundColor: '#fff',
						borderRadius: '12px',
						height: '56px',
						px: 2,
						'& input::placeholder': {
							color: '#000',
							opacity: 0.7,
							fontWeight: 500,
						},
						'& input:-webkit-autofill': {
							boxShadow: '0 0 0 1000px #fff inset',
							WebkitTextFillColor: '#000',
							fontWeight: 500,
						},
					},
				}}
				sx={{
					'& .MuiOutlinedInput-root': {
						'& fieldset': {
							borderColor: '#fff',
						},
						'&:hover fieldset': {
							borderColor: '#ccc',
						},
						'&.Mui-focused fieldset': {
							borderColor: '#888',
						},
					},
				}}
			/>

			<Link onClick={() => toast.success(HelperTexts.CONTACT_US)} textAlign="right" fontWeight={600} fontSize={16}>
				Forgot Password
			</Link>

			{/* <Button loading={loading} type="primary" size="medium" onClick={handleLogin}>
				Sign In
			</Button> */}

			<Button
				variant="contained"
				color="info"
				fullWidth
				onClick={handleLogin}
				disabled={loading}
				sx={{
					mt: 2,
					py: 3.5,
					fontWeight: 600,
					fontSize: '18px',
					borderRadius: '12px',
					// backgroundColor: AppColors.Primary_shade,
					color: '#fff',
					textTransform: 'none',
				}}
			>
				{loading ? 'Loading...' : 'Login'}
			</Button>

			{SIGN_UP_FLOW && (
				<>
					<Typography textAlign="center" fontSize={14} fontWeight={400} color={AppColors.TEXT_TERTIARY}>
						or
					</Typography>

					<Button icon={<img alt="google" width={16} src={googleIcon} />} type="default" color="secondary">
						Login with Google
					</Button>
					<Button icon={<FaApple size={18} />} style={{ backgroundColor: AppColors.BLACK }} type="primary">
						Login with Apple
					</Button>
				</>
			)}

			{/* <Typography textAlign="center" fontWeight={500} fontSize={14} color={AppColors.TEXT_TERTIARY}>
				Don’t have an account? <Link onClick={() => toast.success(HelperTexts.CONTACT_US)}>Sign Up</Link>
			</Typography> */}
		</LoginLayout>
	);
}